export class MoleculePanelOverviewHeaderMultiWipeDatabaseActionComponent {
    public templateUrl = require('./multi-wipe-database-action.html?external');
}
